import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import React from "react";
const firebase = require("firebase");
require("firebase/firestore");

const styles = theme => ({
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1)
  }
});
class SolicitudesForm extends React.Component {
  constructor() {
    super();
    this.state = {
      nombre: "",
      telefono: "",
      email: "",
      reclamo: "",
      asunto: "",
      inputLabel: React.createRef(),
      labelWidth: 0
    };
  }
  componentDidMount = () => {
    // const user = firebase.auth().currentUser.displayName;
    this.setState({ labelWidth: this.state.inputLabel.current.offsetWidth });
  };
  save = async () => {
    if (
      this.state.nombre.length > 0 &&
      this.state.telefono.length > 0 &&
      this.state.email.length > 0 &&
      this.state.reclamo.length > 0 &&
      this.state.asunto.length > 0
    ) {
      try {
        await firebase
          .firestore()
          .collection("solicitudes")
          .add({
            nombre: this.state.nombre,
            telefono: this.state.telefono,
            email: this.state.email,
            reclamo: this.state.reclamo,
            asunto: this.state.asunto,
            timestamp: firebase.firestore.FieldValue.serverTimestamp()
          });
        this.setState({
          nombre: "",
          telefono: "",
          email: "",
          reclamo: "",
          asunto: ""
        });
      } catch (error) {
        console.log(error.message);
      }
    } else {
      console.log("Porfavor llene todos los campos");
    }
  };
  render() {
    const { classes } = this.props;
    return (
      <div
        style={{
          textAlign: "center",
          display: "flex",
          flexDirection: "column"
        }}
      >
        <TextField
          label="Nombre"
          value={this.state.nombre}
          onChange={e => this.setState({ nombre: e.target.value })}
          className={classes.textField}
          margin="normal"
          variant="outlined"
        />
        <TextField
          label="Telefono"
          value={this.state.telefono}
          onChange={e => this.setState({ telefono: e.target.value })}
          className={classes.textField}
          margin="normal"
          variant="outlined"
        />
        <TextField
          label="Email"
          value={this.state.email}
          onChange={e => this.setState({ email: e.target.value.toLowerCase() })}
          className={classes.textField}
          margin="normal"
          variant="outlined"
        />
        <FormControl
          variant="outlined"
          //className={classes.formControl}
        >
          <InputLabel
            ref={this.state.inputLabel}
            id="demo-simple-select-outlined-label"
          >
            Tipo de Seguro
          </InputLabel>
          <Select
            labelId="demo-simple-select-outlined-label"
            id="demo-simple-select-outlined"
            value={this.state.reclamo}
            onChange={e => this.setState({ reclamo: e.target.value })}
            labelWidth={this.state.labelWidth}
          >
            <MenuItem value={"Auto"}>Auto</MenuItem>
            <MenuItem value={"Vida"}>Vida</MenuItem>
            <MenuItem value={"Gastos Medicos"}>Gastos Medicos</MenuItem>
            <MenuItem value={"Inacapacidad"}>Inacapacidad</MenuItem>
            <MenuItem value={"Daños empresariales"}>
              Daños empresariales
            </MenuItem>
            <MenuItem value={"Daños hogar"}>Daños hogar</MenuItem>
            <MenuItem value={"Responsabilidad civil"}>
              Responsabilidad civil
            </MenuItem>
            <MenuItem value={"Tercero afectado"}>Tercero afectado</MenuItem>
            <MenuItem value={"Otros"}>Otros</MenuItem>
          </Select>
        </FormControl>
        <TextField
          label="Consulta"
          value={this.state.asunto}
          onChange={e => this.setState({ asunto: e.target.value })}
          className={classes.textField}
          multiline
          rows="5"
          margin="normal"
          variant="outlined"
        />
        <Button
          onClick={this.save}
          style={{ margin: "6px" }}
          variant="contained"
          color="primary"
        >
          Enviar
        </Button>
      </div>
    );
  }
}

export default withStyles(styles)(SolicitudesForm);
